var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blocks block",class:[
    _vm.lift ? '_lift' : '',
    _vm.noBorder ? '_no-border' : ''
  ]},[(_vm.hasHeaderSlot)?_vm._t("header"):_vm._e(),(_vm.hasDefaultSlot)?_vm._t("default"):_c('div',[(_vm.label && _vm.label !== '')?_c('span',{staticClass:"-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.data)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }